import { EventType } from "../../../../common/enums";
import { EventTypeLabels } from "../../../../common/labels";

export const getEventType = () => {
  return [
    { id: EventType.Group, name: EventTypeLabels[EventType.Group] },
    { id: EventType.Individual, name: EventTypeLabels[EventType.Individual] },
  ];
};
